




import {Component, Prop} from 'vue-property-decorator';
import EntityType from "@/models/Shared/EntityType";
import ComponentLocation from '@/models/Shared/ComponentLocation';
import GiganautVue from '@/components/Shared/GiganautVue';
import BookingRoleWorkerStatus from '@/models/BookingRoleWorkers/BookingRoleWorkerStatus';


@Component({
  name: 'ShiftBookedStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	required: number;

	@Prop({required: true})
	booked: number;

	@Prop({required: true})
	bookedUnconfirmed: number;

	@Prop({required: true})
	bookedConfirmed: number;

	@Prop({required: true})
	showPercentage: boolean;

	@Prop({required: true})
	showRatio: boolean;

	@Prop({required: true})
	showXSmall: boolean;

	get color() {
		let color = "orange";
		const percentage = this.bookedPercentage();
		if (percentage == 100){
			color = "green"
		} else if (percentage == 0) {
			color = "red";
		} else if (percentage > 100) {
			color = "dark green"
		}
		return color;
	}
	
	get textColor() {
		let color = "black";
		const percentage = this.bookedPercentage();
		if (percentage == 100){
				color = "black";
		} else if (percentage == 0) {
			color = "white";
		} else if (percentage > 100) {
			color = "black"
		}
		return color;
	}

	get text() {
		let text = "";
		if (this.showRatio){
			text = this.booked + "/" + this.required;
		}
		if (this.showPercentage) {
			const percentage = this.bookedPercentage();
			if (text !== "") {
				text = text + " ";
			}
			text = text + "" + percentage + "%";
		}
		return text;
	}

	get outlined() {
		const percentage = this.bookedPercentage();
		console.log(this.bookedUnconfirmed)
		//if (percentage >= 100){
			if (this.bookedUnconfirmed > 0) {
				return true;
			}
		//}
		return false;
	}
	
	bookedPercentage() {
		const percentage = 0;
		if (this.booked == 0) {
			return 0;
		}
		return Math.round((this.booked / this.required)*100);
	}
}
